<template>
  <router-link v-if="!noLink" :to="to">
    <img src="@/assets/img/Maintenance.png" v-bind="imgAttrs" />
  </router-link>
  <img v-else src="@/assets/img/Maintenance.png" v-bind="imgAttrs" />
</template>

<script>
  export default {
    name: 'MaintenanceLogo',

    props: {
      width: {
        type: String,
        default: '170px',
      },

      to: {
        type: [String, Object],
        default: () => ({ name: 'Home' }),
      },

      lg: Boolean,
      noLink: Boolean,
    },

    computed: {
      imgAttrs() {
        return {
          alt: '',
          width: this.lg ? '500px' : this.width,
        };
      },
    },
  };
</script>
